import * as React from "react";
import { Typography, Card, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { CustomButton } from "../components/CustomButton";
import { styles } from "../theme/styles";

/**
 * Reemplaza el Swal.fire que hoy abre el ícono ⓘ de la tabla.
 * Muestra clusters (chips) y mínimo de pedido, con botones para entrar
 * a edición de cada bloque (los edita EditarClustersModal / EditarMinimosModal,
 * que el padre abre por separado — este componente no edita nada, solo muestra).
 */
export default function DetalleProveedorModal({
  open,
  provider, // { name (o nameProvider), idNumber }
  clusterNames, // string[]
  onClose,
  onEditClusters,
  onEditMinimos,
}) {
  if (!open || !provider) return null;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1000,
        backgroundColor: "rgba(58, 58, 58, 0.8)",
      }}>
      <Card className="div-detalle-prov">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}>
          <div>
            <Typography variant="h5" color="primary" style={styles.textin}>
              {provider.name || provider.nameProvider}
            </Typography>
            <Typography variant="body1" color="textSecondary">
              ID {provider.idNumber}
            </Typography>
          </div>
          <IconButton onClick={onClose} size="medium">
            <CloseIcon fontSize="medium" />
          </IconButton>
        </div>

        <div className="div-detalle-bloque">
          <div className="div-detalle-bloque-head">
            <span>Clusters asignados</span>
            <span className="link-editar" onClick={onEditClusters}>
              Editar clusters
            </span>
          </div>
          <div className="cluster-chip-grid detalle">
            {clusterNames && clusterNames.length > 0 ? (
              clusterNames.map((name) => (
                <div key={name} className="cluster-chip readonly">
                  {name}
                </div>
              ))
            ) : (
              <p style={{ fontSize: "0.9rem", color: "#8B93A1" }}>
                Este proveedor no tiene clusters asignados.
              </p>
            )}
          </div>
        </div>

        <div className="div-detalle-bloque">
          <div className="div-detalle-bloque-head">
            <span>Mínimo de pedido</span>
            <span className="link-editar" onClick={onEditMinimos}>
              Editar mínimo
            </span>
          </div>
          <p style={{ fontSize: "0.85rem", color: "#8B93A1" }}>
            El mínimo se define por tienda. Dale a "Editar mínimo" para verlo o
            capturarlo.
          </p>
        </div>
      </Card>
    </div>
  );
}
